export default {

    "title": "Protocol",
    "entityName": "protocol",
    "noLabelUpsertBtn":true,
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [
        {
            md:12,
            value: "name",
            text: "Name",
            type: "text",
            table: {
                sortable: true,
                filter: true
            },
            validators: [
                "required"
            ],
            readonly: item => !!item.map_name
        },
        {
            slim:true,
            value: "sponsor_id",
            text: "Sponsor",
            type: "list",
            "item-id": "id",
            "item-text": "name",
            list: [],
            table: { "filter": true },
            validators: [
                "required"
            ],
            render: (item) => {
                return item.sponsor.name
            },
            visible: false,
            default: () => { return -1 },
            deps: ['name']
        },
       
        {
            md:12,
            value: "budget",
            text: "Budget",
            type: "number",
            clearable:true,
            table: {
                sortable: true,
                filter: true
            },
        },

        {
            type: 'hidden',
            value: 'provider',
            default: () => { return 'N/A' },
            deps: ['name']
        },
        {
            mid:true,
            "value": "status",
            "text": "Status",
            "type": "list",
            visible: (item) => { return  item.provider==='N/A' || !item._exists ? true :false },
            "list": ["Open", "Closed", "Draft"],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

        // {
        //     slim:true,
        //     value: "co_sponsors",
        //     text: "Co Sponsors",
        //     append_icon: '',
        //     multiple: true,
        //     chips: true,
        //     deletable_chips:true,
        //     items:['EMN'],
        //     placeholder: '',
        //     loadRemote: false,
        //     type: "combobox",
        // },



        // {
        //     full:true,
        //     value: "account_activators",
        //     text: "User Activators",
        //     multiple: true,
        //     chips: true,
        //     items:[],
        //     deletable_chips:true,
        //     placeholder: '',
        //     loadRemote: true,
        //     type: "autocomplete",
        //     id:"id",
        //     subtitle:"email",
        //     reference: "account",
        //     default: () => undefined,
        //     filter: (item, search) => { return { urs : [{ 'name': `%${search}%`}, { 'surname': `%${search}%`}, { 'email': `%${search}%`}], 'role':`Administrator`} },
        //     title: (item) => item.name + ' ' + item.surname
        // },

        // {
        //     full:true,
        //     value: "email_activators",
        //     text: "User Activators Emails",
        //     multiple: true,
        //     chips: true,
        //     items:[],
        //     deletable_chips:true,
        //     placeholder: '',
        //     loadRemote: false,
        //     type: "combobox",
        // },


        // {
        //     "value": "n_patients",
        //     "text": "N. max patients",
        //     "type": "number",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },            
        //     "validators": [
        //         "required",
        //         "number"
        //     ]
        // },
          
    ],
    "actions": [
        'upsert',
        // { "value": "upsert", "text": "Upsert", "icon": "mdi-pencil", "color": "primary", "disable" : (item) => { return item.map_name} },
        { "value": "remove", "text": "Remove", "icon": "mdi-delete", "color": "primary", "disable" : (item) => { return item.map_name} },
        "audit_trail"
    ]
}